import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useT } from "@/lib/i18n";

export default function FAQSection() {
  const { t } = useT();
  const faqs = [
    { q: t("faq_q1"), a: t("faq_a1") },
    { q: t("faq_q2"), a: t("faq_a2") },
    { q: t("faq_q3"), a: t("faq_a3") },
    { q: t("faq_q4"), a: t("faq_a4") },
    { q: t("faq_q6"), a: t("faq_a6") },
  ];

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-32 bg-white"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="text-xs font-semibold tracking-widest uppercase text-sunset mb-3">
            {t("faq_label")}
          </div>
          <h2 className="font-heading font-black text-4xl sm:text-5xl text-slate-900 leading-tight">
            {t("faq_title_a")}
            <br />
            <span className="text-ocean">{t("faq_title_b")}</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-slate-100 rounded-2xl bg-white shadow-soft px-5 sm:px-6"
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-base sm:text-lg text-slate-900 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 text-sm sm:text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
